import { AbstractButton, AbstractButtonProps } from '@app/site/_form/button/AbstractButton';
import React, { PropsWithChildren } from 'react';
import { useFormContext } from '@app/site/_form';


type SubmitButtonProps = Omit<AbstractButtonProps, 'isSubmitting' | 'onSubmit' |'isLink' | 'to'> & {
	/** Set false when the enclosing form handles native submission. */
	submitOnClick?: boolean
}

export const SubmitButton: React.FunctionComponent<PropsWithChildren<SubmitButtonProps>> = ({children, submitOnClick = true, ...props}) => {
	const form = useFormContext()

	return <form.Subscribe selector={(state) => state.isSubmitting}>
		{(isSubmitting) => <AbstractButton {...props} type='submit' isSubmitting={isSubmitting} onClick={submitOnClick ? form.handleSubmit : undefined}>{children}</AbstractButton>}
	</form.Subscribe>
};